import React from "react";
import SwipeNav from "../../../Components/SwipeNav/SwipeNav";
import Saving from "../Savings/Savings";
import EIA from "../Eia/Eia";

let Components = [<Saving />, <EIA />];

const WhySolarHome = () => {
  return <SwipeNav Components={Components}></SwipeNav>;
};

export default WhySolarHome;
